import * as React from "react";
import { MenuButton, IMenuItem } from "azure-devops-ui/Menu";

export default class SubmenuExample extends React.Component {
    private menuWithSubMenu: IMenuItem[] = [
        { id: "one", text: "MenuItem 1" },
        {
            id: "two",
            text: "MenuItem 2",
            subMenuProps: {
                id: "sub-menu",
                items: [
                    { id: "submenu-one0", text: "SubMenuItem 1" },
                    { id: "submenu-two0", text: "SubMenuItem 2" },
                    { id: "submenu-one1", text: "SubMenuItem 3" },
                    { id: "submenu-two1", text: "SubMenuItem 4" },
                    { id: "submenu-one2", text: "SubMenuItem 5" },
                    { id: "submenu-two2", text: "SubMenuItem 6" },
                    { id: "submenu-one3", text: "SubMenuItem 7" },
                    { id: "submenu-two3", text: "SubMenuItem 8" },
                    { id: "submenu-one4", text: "SubMenuItem 9" },
                    { id: "submenu-two4", text: "SubMenuItem 10" },
                    { id: "submenu-one5", text: "SubMenuItem 11" },
                    { id: "submenu-two5", text: "SubMenuItem 12" },
                    { id: "submenu-one6", text: "SubMenuItem 13" },
                    { id: "submenu-two6", text: "SubMenuItem 14" }
                ]
            }
        },
        { id: "three", text: "MenuItem 3" }
    ];

    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <MenuButton
                    text="Menu with sub menus"
                    contextualMenuProps={{
                        menuProps: {
                            id: "test",
                            items: this.menuWithSubMenu
                        }
                    }}
                />
            </div>
        );
    }
}
